<template>
  <v-row>
    <v-col cols="12">
      <v-row cols="12">
        <v-col cols="6">
          <v-select
            v-model="pieceAjout"
            :items="itemsPieces"
            hint="Type de pièce"
            item-text="libelle"
            item-value="id"
            label="Choix du type de pièce"
            persistent-hint
            return-object
            single-line
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-btn
            small
            color="normal"
            @click="addPiece()"
            :loading="loading"
            :disabled="!pieceAjout.id"
          >
            <v-icon title="Ajouter un type de pièce">mdi-plus</v-icon>Ajouter
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="piecesAFournir"
        :items-per-page="10"
        item-key="id"
        class="elevation-1"
        dense
      >
        <template v-slot:[`item.obligatoire`]="{ item }">
          <v-checkbox v-model="item.obligatoire"></v-checkbox>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <ActionConfirmation
            icone="mdi-delete"
            title="Dissocier le type de piece"
            @ok="dissocierPiece(item.id)"
          ></ActionConfirmation>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>
<script>
import ActionConfirmation from "@/components/ActionConfirmation";

import ApiTypePieceRepository from "@/repositories/ApiTypePieceRepository";

export default {
  name: "ListeTypesPiece",
  props: { piecesAFournir: { type: Array, required: true } },
  components: { ActionConfirmation },
  data() {
    return {
      itemsPieces: [],
      pieceAjout: {},
      loading: false,
      headers: [
        {
          text: "Libelle",
          align: "left",
          value: "libelle",
        },
        {
          text: "Obligatoire",
          align: "center",
          value: "obligatoire",
        },
        {
          text: "Action",
          align: "center",
          value: "action",
        },
      ],
    };
  },
  methods: {
    dissocierPiece(idTypePiece) {
      this.$emit("dissocierPiece", idTypePiece);
    },
    addPiece() {
      let idPiece = this.piecesAFournir.findIndex(
        (p) => p.id === this.pieceAjout.id
      );

      if (idPiece == -1) {
        this.$emit("addPiece", this.pieceAjout);
      }
    },
    async getTypePieces() {
      try {
        const typesPieces = await ApiTypePieceRepository.getTypesPieces();
        this.itemsPieces = typesPieces.filter((p) => p.deposable);
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
  },
  created() {
    this.getTypePieces();
  },
};
</script>
